import { removeDuplicatesFromArray } from '@/utils/removeDuplicatesFromArray';

export function getNumberOfUniqueValuesInArray(array: any[]) {
  if (!Array.isArray(array)) {
    throw new Error(`Unable to get number of unique values in array - array argument is not an Array: ${typeof array}.`);
  }

  return removeDuplicatesFromArray(array).length;
}
